import { useSession } from "next-auth/client";
import { repository } from "repositories";
import { GetCallEndNotificationListParams } from "repositories/CallEndNotificationRepository";
import { defaultPaginationMeta } from "shared/constants";
import useSWR from "swr";

export const useCallEndNotificationList = (
  params?: GetCallEndNotificationListParams
) => {
  const [session] = useSession();

  const { data, error, isValidating } = useSWR(
    session
      ? repository.callEndNotification.getCallEndNotificationListPath()
      : null,
    async () => {
      return repository.callEndNotification.getCallEndNotificationList(params);
    },
    {
      fallbackData: {
        callEndNotifications: [],
        meta: defaultPaginationMeta,
      },
    }
  );

  return {
    ...data,
    isLoading: (!error && !data) || isValidating,
    isError: !!error,
  };
};
